import { render, staticRenderFns } from "./Visitors.vue?vue&type=template&id=1b6450aa&scoped=true"
import script from "./Visitors.vue?vue&type=script&lang=js"
export * from "./Visitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6450aa",
  null
  
)

export default component.exports